// Pop Up window
const testimonialsSlides = document.querySelectorAll('.swiper-slide');
const closeButton = document.querySelector('.close');
const previousSlideButton = document.querySelector('.pop-up-prev');
const nextSlideButton = document.querySelector('.pop-up-next');

let activeWindow = 0;
const testimonialWindow = document.getElementById('testimonials');
const sliderSection = document.querySelector('.swiper');

const popupDescription = document.querySelector('.pop-up__content > .testimonials__descriptions');
const popupName = document.querySelector('.testimonials__contact > .testimonials__person');
const popupCompany = document.querySelector('.testimonials__contact > .testimonials__company');

if (document.getElementById('testimonials') !== null) {
  let arrayTestimonials;
  let currentTestimonialId;

  document.addEventListener('click', (event) => {

    if (testimonialWindow.contains(event.target)) {
      testimonialWindow.classList.remove('active');
      sliderSection.style.opacity = '1';

      activeWindow = 0;
    }
  });

  // When user clicks on testimonial
  testimonialsSlides.forEach((button) => {

    button.addEventListener('click', () => {

      const testimonials = button.getAttribute('data-testimonials');
      arrayTestimonials = JSON.parse(testimonials);

      currentTestimonialId = Number(button.getAttribute('data-id'));

      popupDescription.innerHTML = arrayTestimonials[currentTestimonialId].description;
      popupName.innerHTML = arrayTestimonials[currentTestimonialId].person_name;
      popupCompany.innerHTML = arrayTestimonials[currentTestimonialId].company;

      testimonialWindow.classList.add('active');
      sliderSection.style.opacity = '0.5';

      activeWindow = 1;
    });
  });

  previousSlideButton.addEventListener('click', () => {

    if (currentTestimonialId === 0) currentTestimonialId = arrayTestimonials.length - 1;
    else {
      currentTestimonialId -= 1;
    }

    popupDescription.innerHTML = arrayTestimonials[currentTestimonialId].description;
    popupName.innerHTML = arrayTestimonials[currentTestimonialId].person_name;
    popupCompany.innerHTML = arrayTestimonials[currentTestimonialId].company;
  });

  nextSlideButton.addEventListener('click', () => {

    if (currentTestimonialId === arrayTestimonials.length - 1) currentTestimonialId = 0;
    else {
      currentTestimonialId += 1;
    }

    popupDescription.innerHTML = arrayTestimonials[currentTestimonialId].description;
    popupName.innerHTML = arrayTestimonials[currentTestimonialId].person_name;
    popupCompany.innerHTML = arrayTestimonials[currentTestimonialId].company;
  });

  closeButton.addEventListener('click', () => {
    testimonialWindow.classList.remove('active');
    sliderSection.style.opacity = '1';

    activeWindow = 0;
  });
}
